import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Axios from 'axios';

import ProgressIndicator from '../../Common/ProgressIndicator';
import ErrorIndicator from '../../Common/ErrorIndicator';

import EventEditForm from './EventEditForm';

function EventEditPage(props) {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(false);
    const [event, setEvent] = useState(null);
    const { id } = useParams();

    useEffect(() => {
        setIsLoading(true);
        Axios.get(`/admin/events/${id}`).then(res => {
            setEvent(res);
            setIsLoading(false);
        }, err => {
            setIsLoading(false);
            setError(true);
        });
    }, [id]);

    if (isLoading)
        return <ProgressIndicator />;

    if (error)
        return <ErrorIndicator text="A rendezvény letöltése sikertelen." />;

    if (event)
        return (
            <>
                <h1>Rendezvény szerkesztése</h1>
                <EventEditForm event={event} />
            </>
        );

    return null;
}

export default EventEditPage;